<template>
  <div
    class="bg-primary"
    :class="gdqmodeclass"
  >
    <b-modal
      v-model="gdq_recertification"
      size="lg"
      @hidden="recertify_redirect"
    >
      <div v-html="gdq_recertification_text" />
    </b-modal>
    <b-navbar
      sticky
      toggleable="lg"
      type="dark"
      :class="gdqmodeclass"
      class="container-xl mx-auto"
    >
      <b-navbar-brand
        left
        to="/"
        tag="h1"
        class="item-text"
      >
      <LogoStyleGuide />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <!-- Right aligned nav items -->
        <b-navbar-nav
          class="ml-auto bg-primary pl-2"
          :class="gdqmodeclass"
        >
          <b-nav-item
            :disabled="consultantstatus && consultantstatus.can_do_survey ==='0'"
            href="/tutorials"
          >
            Resources
          </b-nav-item>
          <b-nav-item
            :disabled="consultantstatus && consultantstatus.can_do_survey ==='0'"
            v-if="faqs == true"
            href="/faq"
          >
            <span>Support</span>
          </b-nav-item>
          <b-nav-item
            href="#"
          >
            <span>Notifications <span class="noti-circle">1</span></span>
          </b-nav-item>
          <b-nav-item-dropdown class="name-dropdown">
            <template slot="button-content">
              Namn Namnsson
            </template>
            <b-dropdown-item
              v-if="is_consultant == true"
              href="/"
            >
              <b-link
                class="text-primary"
                to="/"
              >
                <i class="fa-regular fa-gauge"></i>Dashboard
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="is_consultant == true"
              href="/profile"
            >
              <b-link
                to="/profile"
              >
              <i class="fa-regular fa-user"></i>My Profile
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="is_consultant == true"
              href="#"
            >
              <b-link
                to="#"
              >
              <i class="fa-regular fa-square-poll-vertical"></i>My Surveys
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="is_consultant == true"
              href="#"
            >
              <b-link
                to="#"
              >
              <i class="fa-regular fa-credit-card-blank"></i>Billing & Payments
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="is_admin == true"
              href="#"
            >
              <b-link
                to="#"
              >
              <i class="fa-regular fa-user-cog"></i>Admin
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item href="#">
            <span class="text-danger"
              @click="logout"
            >Log out</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal
      v-model="showmessages"
      title="System Messages"
      size="lg"
      ok-only
    >
      <div
        v-for="message in messagesmenu"
        :key="message.id"
        class="pl-4"
      >
        <b-row
          style="cursor:pointer"
          class="col-12 mb-1 py-1"
          :class="'bg-'+messagevariants[message.message_severity]"
          @click.prevent="message_show(message.id)"
        >
          <span
            class="gdq-w-50px pt-1"
          >
            <span
              :title="message.status=='read'?'Set as unread':'Set as read'"
              @click.prevent.stop="message_setstatus(message.id,message.status=='read'?'unread':'read')"
            >
              <fa-icon
                :name="message.status=='read'?'envelope-open':'envelope'"
                class="mr-2 mt-0"
              />
            </span>
            <fa-icon
              :name="showingmessage==message.id?'chevron-down':'chevron-right'"
              class="mr-2 mt-0"
            />
          </span>
          <span
            class="gdq-w-50px pt-1"
          >
            {{ message.message_activation_date }}
          </span>
          <span class="pt-1">
            {{ message.message_heading }}
          </span>
        </b-row>
        <div
          v-show="showingmessage==message.id"
          v-html="message.message_message"
        />
      </div>
    </b-modal>
    <b-modal
      v-model="showmain"
      size="lg"
      title="Messages from GDQ Associates"
      ok-only
    >
      <b-alert
        v-for="message in messagesmain"
        :key="message.id"
        :variant="messagevariants[message.message_severity]"
        show
      >
        <h3>{{ message.message_heading }}</h3>
        <span
          v-html="message.message_message"
        />
      </b-alert>
      <template slot="modal-footer">
        <b-form-checkbox v-model="dontshowmotd">
          Don't show this message again
        </b-form-checkbox>
        <b-button
          @click.prevent="main_close()"
        >
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { config } from '../../../config'
import LogoStyleGuide from './LogoStyleGuide.vue'
export default {
  components: {
    LogoStyleGuide
  },
  data () {
    return {
      anon: this.$store.state.anon,
      asadmin: this.$store.state.asadmin,
      user: this.$store.state.user,
      profile: this.$store.state.profile,
      gdqmodeclass: 'bg-primary',
      search: '',
      is_consultant: false,
      is_tot: false,
      is_admin: false,
      lastlogin_months: 0,
      gdq_recertification_months: 1000,
      gdq_recertification_text: '',
      gdq_recertification: false,
      faqs: false,
      messagesmenu: [],
      messagesmain: [],
      showmessagesicon: false,
      showmessages: false,
      showmain: false,
      showingmessage: 0,
      unreadmessages: 0,
      dontshowmotd: false,
      messagevariants: [
        '',
        '',
        '',
        'warning',
        'danger'
      ],
      nowdate: new Date().toISOString().substring(0, 10)
    }
  },
  computed: {
    consultantstatus: function () {
      const consultantstatus = this.$store.state.consultantstatuses.find(s => s.id === this.profile.consultantstatus_id)
      return consultantstatus
    }
  },
  created () {
    this.user_get()
    // this.check_oldlogin();
    this.messages_get()
    this.faqs_get()
    this.user_role_set()
  },
  methods: {
    toggleanon (e) {
      this.$store.dispatch('toggleanon')
    },
    recertify_redirect () {
      this.$router.push('/login')
    },
    check_oldlogin () {
      // This one works, but we need to reset i_user.last_login to i_user.prev_login,
      // otherwise the user can log in the second time
      this.lastlogin_months = 0
      if (this.user.prev_login !== null) {
        const d1 = new Date(this.user.prev_login.replace(' ', 'T'))
        const d2 = new Date()
        let months = 0
        months = (d2.getFullYear() - d1.getFullYear()) * 12
        months -= d1.getMonth() + 1
        months += d2.getMonth() + 1
        this.lastlogin_months = months
        this.$store.dispatch('syspref_get', { name: 'gdq_recertification_months' })
          .then((resp) => {
            this.gdq_recertification_months = resp.data.value
            if (parseInt(this.lastlogin_months) >= parseInt(this.gdq_recertification_months)) {
              this.$store.dispatch('syspref_get', { name: 'gdq_recertification_text' })
                .then((resp) => {
                  this.gdq_recertification_text = resp.data.value
                  this.gdq_recertification = true
                })
            }
          })
      }
    },
    user_get () {
      this.$store.dispatch('user_fetch').then(() => {
        this.user = this.$store.state.user
      })
    },
    main_close () {
      this.showmain = false
      if (this.dontshowmotd == true) {
        for (let i = 0; i < this.messagesmain.length; i++) {
          this.message_setstatus(this.messagesmain[i].id, 'read')
        }
      }
    },
    messages_show () {
      this.showmessages = true
      this.showingmessage = 0
    },
    message_show (message_id) {
      this.showingmessage = this.showingmessage == message_id ? 0 : message_id
      if (this.showingmessage != 0) {
        this.message_setstatus(this.showingmessage, 'read')
      }
    },
    messages_get () {
      this.$store.dispatch('usersystemmessages_fetch', { user_id: this.$store.state.user_id })
        .then((resp) => {
          this.messagesmenu = resp.data.result
          this.showmessagesicon = this.messagesmenu.length > 0
          const unreadlist = this.messagesmenu.filter(m => m.status == 'unread')
          this.unreadmessages = unreadlist.length
          this.messagesmain = this.messagesmenu.filter(m => m.status == 'unread' && m.always_show == 1)
          this.showmain = this.messagesmain.length > 0 && this.$route.path == '/'
        })
    },
    message_setstatus (message_id, status) {
      this.$store.dispatch('usersystemmessage_setstatus', { user_id: this.$store.state.user_id, message_id: message_id, message_status: status })
        .then(() => {
          this.messages_get()
        })
    },
    logout: function () {
      this.$store
        .dispatch('logout', {})
        .then(() => this.$router.push('/login'))
        // eslint-disable-next-line
        .catch(err => console.log(err));
    },
    user_role_set () {
      for (var i = 0; i < this.$store.state.user_usergroups.length; i++) {
        if (this.$store.state.user_usergroups[i].usergroup_id == 1) { this.is_consultant = true }
        if (this.$store.state.user_usergroups[i].usergroup_id == 2) { this.is_admin = true }
        if (this.$store.state.user_usergroups[i].usergroup_id == 8) { this.is_tot = true }
      }
    },
    user_status_set () {

    },
    faqs_get () {
      this.$store.dispatch('records_readall', { table_name: 'g_faq' })
        .then((resp) => {
          if (resp.data.result.length > 0) {
            this.faqs = true
          }
        })
    }
  }
}
</script>
<style scoped>
a.nav-link {
  color: white !important;
}
a.nav-link.dropdown-toggle {
  color: white !important;
}
</style>
